<template>
    <div>
        <div class="profile-form bg-white p-3 rounded">
            <h5 class="font-weight-bold f-20 text-left mt-2">{{ $t('profilePassword.title') }}</h5>
            <b-form @submit.prevent="updatePassword">
                <b-row>
                    <b-col sm="8">
                        <b-form-group :label="$t('profilePassword.oldPasswordLabel')" label-for="password-3" class="text-left password mb-3">
                            <b-form-input :type="showPassword1 ? 'text' : 'password'" id="password-1"
                                :placeholder="$t('profilePassword.oldPasswordPlaceholder')" v-model="passwords.user.old_password"
                                required></b-form-input>
                            <b-icon :icon="showPassword1 ? 'eye-fill' : 'eye-slash-fill'"
                                @click="showPassword1 = !showPassword1" style="fill:black"></b-icon>
                        </b-form-group>
                    </b-col>
                    <b-col sm="8">
                        <b-form-group :label="$t('profilePassword.newPasswordLabel')" label-for="password-3" class="text-left password mb-3">
                            <b-form-input :type="showPassword2 ? 'text' : 'password'" id="password-2"
                                :placeholder="$t('profilePassword.newPasswordPlaceholder')" v-model="passwords.user.new_password"
                                required></b-form-input>
                            <b-icon :icon="showPassword2 ? 'eye-fill' : 'eye-slash-fill'"
                                @click="showPassword2 = !showPassword2" style="fill:black"></b-icon>
                        </b-form-group>
                    </b-col>
                    <b-col sm="8">
                        <b-form-group :label="$t('profilePassword.confirmPasswordLabel')" label-for="password-3" class="text-left password mb-3">
                            <b-form-input :type="showPassword3 ? 'text' : 'password'" id="password-3"
                                :placeholder="$t('profilePassword.confirmPasswordPlaceholder')" v-model="passwords.user.confirm_password"
                                required></b-form-input>
                            <b-icon :icon="showPassword3 ? 'eye-fill' : 'eye-slash-fill'"
                                @click="showPassword3 = !showPassword3" style="fill:black"></b-icon>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12">
                        <div class="d-flex align-items-center flex-wrap">
                            <b-button to="/" class="mx-0 h-40px w-100px mt-3 mr-3 m-0" variant="secondary">{{ $t('profilePassword.close') }}</b-button>
                            <b-button v-if="passwords.user.old_password && passwords.user.new_password && passwords.user.confirm_password" class="mt-3 save h-40px w-100px m-0" variant="primary" type="submit">{{ $t('profilePassword.save') }}</b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-form>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "Password",
    data() {
        return {
            showPassword1: false,
            showPassword2: false,
            showPassword3: false,
            passwords: {
                user: {
                    old_password: null,
                    new_password: null,
                    confirm_password: null,
                },
            },
        }
    },
    computed: {
        ...mapGetters(['user'])
    },
    methods: {
        ...mapActions(['setNotification', 'updateTeamMember']),
        async updatePassword() {
            if (
                this.passwords.user.new_password === this.passwords.user.old_password
            ) {
                await this.setNotification({
                    msg: this.$t('profilePassword.oldEqualsNew'),
                    type: "error",
                    color: "red",
                });
            } else if (
                this.passwords.user.new_password ===
                this.passwords.user.confirm_password
            ) {
                try {
                    await this.updateTeamMember({
                        id: this.user.team_member.id,
                        payload: this.passwords,
                    });
                    await this.setNotification({
                        msg: this.$t('profilePassword.passwordUpdated'),
                        type: "success",
                        color: "green",
                    });
                    this.passwords = {
                        user: {
                            old_password: null,
                            new_password: null,
                            confirm_password: null,
                        },
                    }
                } catch (error) {
                    await this.setNotification({
                        msg: error,
                        type: "error",
                        color: "red",
                    });
                }
            } else {
                await this.setNotification({
                    msg: this.$t('profilePassword.passwordMismatch'),
                    type: "error",
                    color: "red",
                });
            }
        },
    },
}
</script>
<style></style>